import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ElementBaseQuickSettingRect, IQuickSettingRect } from './base';

export class ShapeQuickSettingRect extends ElementBaseQuickSettingRect {
    private shapeModel: IShapeModel;
    public constructor(model: IShapeModel) {
        super(model);
        this.shapeModel = model;
    }

    public getQuickSettingRect(scale: number, isEditorTextExpanded?: boolean): IQuickSettingRect {
        if (this.shapeModel.editorInstance?.isEditing && isEditorTextExpanded) {
            return this.shapeModel.editorInstance.getExpandedRect() as IQuickSettingRect;
        }
        return super.getQuickSettingRect(scale);
    }
}
